import React, { useState, useEffect } from 'react';
import  { useNavigate, useLocation } from 'react-router-dom'
import { api } from '../utils/endpoint.js'


import ThaivivatLogo from '../components/ThaivivatLogo.js'
import iconSuccess from '../images/summary/ic_success.svg'
import iconCoppy from '../images/summary/ic_coppy.svg'
import iconDownload from '../images/summary/ic_download.svg'

import iconBack from '../images/trackdetail/ic_back.svg'
import iconActive from '../images/trackdetail/ic_status_active.svg'
import iconInActive from '../images/trackdetail/ic_status_inactive.svg'
import iconWarning from '../images/trackdetail/ic_warning.svg'

import { convertEngDateToThai, convertEngNoDashDateToThai } from '../utils/convert-date-to-thai'


function InformPage() {

  const navigate = useNavigate();
  const { state } = useLocation()

  const [ referenceNo, setReferenceNo ] = useState('')
  const [ linkDoc, setLinkDoc ] = useState('')


  //รถประกัน หรือ คู่กรณี
  const [ suffererType, setSuffererType ] = useState('')

  //คำนำหน้า
  const [ customerTitleCode, setCustomerTitleCode ] = useState('')
  //ชื่อ นามสกุล
  const [ customerName, setCustomerName ] = useState('')
  //ชื่อ อู่ศูนย์
  const [ garageName, setGarageName ] = useState('')
  //เบอร์
  const [ customerTel, setCustomerTel ] = useState('')
  //Email
  const [ customerEmail, setCustomerEmail ] = useState('')
  //Line
  const [ customerLine, setCustomerLine ] = useState('')

  //ประเภทผู้มาติดต่อ
  const [ contactType, setContactType ] = useState('')

  //ประเภทการเคลม
  const [ documentType, setDocumentType ] = useState('')
  
  //เลขรับแจ้ง
  const [ notifyNo, setNotifyNo ] = useState('')

  //วันที่ส่ง
  const [ confirmDate, setConfirmDate ] = useState('')



  const [ isStatus01, setIsStatus01 ] = useState('')
  const [ isStatus02, setIsStatus02 ] = useState('')
  const [ isStatus03, setIsStatus03 ] = useState('')
  const [ isStatus04, setIsStatus04 ] = useState('')
  const [ isStatus05, setIsStatus05 ] = useState('')


  useEffect(() => {
    window.scrollTo(0, 0)
    if(state !== null && state.referenceNo){
      setReferenceNo(state.referenceNo)
      setLinkDoc(state.linkDoc)
      setCustomerTel(state.customerTel)
      callApiGetTracking(state.referenceNo)
    } else {
      gotoHome()
    }
  }, [])

  function gotoHome(){
    navigate("/", { replace: true })
  }


  function gotoTrackingNo(){
    navigate("/track", { replace: true })
  }

  function gotoInformNew(){
    navigate("/inform", { replace: true })
  }

  function coppyTrackNoToClipboard(){
    navigator.clipboard.writeText(referenceNo)
  }


  async function callApiGetTracking(refno ) {

    const params = `ref_no=${refno}`
    fetch(api.nonemcs.tracking(params))
    .then(response => response.json())
    .then(data => onSuccessCallApiGet(data), (error) => {
      if (error) {
        onFailCallApiGet(error )
      }
    });
  }
  async function onSuccessCallApiGet( data ){
    if(data?.error){
      onFailCallApiGet(data)
      return
    }
    if(data) {
      setNotifyNo(data.notify_number)
      setConfirmDate(data.confirmFormDate)
      setDocumentType(data.claim_type)
      setSuffererType(data.sufferer_type)
      setCustomerTitleCode(data.contact_title_code)
      setCustomerName(data.contact_name)
      setGarageName(data.garage_name )
      setCustomerTel(data.phone_number )
      setCustomerEmail(data.email )
      setCustomerLine( data.line_id )
      setContactType( data.contact_type)

      const status_claims = data.status_claims
      for (let i = 0; i < status_claims.length; i++) {
        const status = status_claims[i]
        if (status.status_id == '01') {
          setIsStatus01(convertEngNoDashDateToThai(status.date)+', '+status.time)
        } 
        else if (status.status_id == '02') {
          setIsStatus02(convertEngNoDashDateToThai(status.date)+', '+status.time)
        } 
        else if (status.status_id == '03') {
          setIsStatus03(convertEngNoDashDateToThai(status.date)+', '+status.time)
        } 
        else if (status.status_id == '04') {
          setIsStatus04(convertEngNoDashDateToThai(status.date)+', '+status.time)
        }
        else if (status.status_id == '05') {
          setIsStatus05(convertEngNoDashDateToThai(status.date)+', '+status.time)
        }
      }

    }
 
  }
  function onFailCallApiGet( error ){
    navigate("/error", { state: { "goPath": '/inform'}, replace: true })
  }


  return (
  <div className="flex-wrap w-full  h-full min-h-screen   md:px-[120px] bg-green-500 font-prompt py-4 px-2 ">

      <div className="flex w-full  flex-wrap  justify-center pb-12">
        <div className="flex w-full h-full  bg-green-500 py-[16px]  justify-center">
          <div className='flex'>
            <ThaivivatLogo></ThaivivatLogo>
          </div>
        </div>

        <div className="flex flex-wrap w-full  lg:w-[974px]   bg-white rounded-xl ">
          
          <div className='flex-wrap flex w-full'>

            <div className=" flex-wrap w-full   p-6 md:py-6   px-4 md:px-6 border-b  flex justify-center  ">
              <div className='flex w-full justify-center'>
                <img src={iconSuccess} alt="icon-success" className='w-[48px] h-[48px]' />
              </div>
              <div className='flex flex-wrap w-full  justify-center'>
                <span className='w-full mt-6 text-xl lg:text-2xl font-medium text-green-500 text-center  '>บริษัท ได้รับข้อมูลเรียบร้อยแล้ว</span>
                <span className='w-full mt-2 text-base font-normal leading-5 text-center text-black '>เราจะตอบกลับภายใน 7 วันทำการ <br/>ผ่านช่องทาง SMS ที่เบอร์ {customerTel}</span>
              </div>
              <div className='flex w-[320px] h-[64px] mt-10 px-4 py-3 rounded-lg border border-grey-300 '>
                <div className='grow w-full flex-wrap '>
                  <span className='flex w-full text-sm font-normal text-grey-600'>เลขที่รายการ</span>
                  <span data-testid='referenceNo-text' className='flex w-full text-base font-normal leading-5 text-green-500'>#{referenceNo}</span>
                </div>
                <div className='flex-none flex'>
                  <div className='flex'>
                    <img data-testid='copy-referenceNo-button' onClick={ (e) => { coppyTrackNoToClipboard() }} src={iconCoppy} alt="icon-copy" className=' cursor-pointer w-[40px] h-[40px]' />
                  </div>
                  <div className='flex'>
                    <a 
                        data-testid='download-button'
                        rel="noopener noreferrer"
                        target={'_blank'}
                        className=' w-fit flex cursor-pointer'
                        href={linkDoc}>
                      <img src={iconDownload} alt="icon-download" className='ml-3 w-[40px] h-[40px]' />
                    </a>
                  </div>
                  
                </div>
              </div>
              <div class=" overflow-hidden w-full justify-end flex pr-[36px]">
                <div class=" h-[10px] w-[16px] bg-blue-200 rotate-45 rounded-t-sm transform origin-bottom-left"></div>
              </div>
              <div className='flex w-full mt-10 justify-center'>
                  <span className='  text-sm font-normal text-grey-600 text-center'>หากคุณไม่ได้รับการติดต่อกลับทาง SMS คุณสามารถติดต่อ<br/>สอบถามเร่งรัดการดำเนินการได้ที่ โทร 
                    <span className='text-green-500'> 1231 กด 4</span>
                  </span>
              </div>
            </div>

        
        
          </div>


          <div className="flex-wrap md:flex-nowrap  flex w-full h-fit md:h-[80px]  border-t border-grey-300 py-4 px-6">
            <div className='md:grow w-full hidden md:flex'>
              <span data-testid='back-to-homePage-button' onClick={gotoHome} className=' cursor-pointer flex text-base font-normal text-green-500 my-auto'>กลับสู่หน้าเว็บไทยวิวัฒน์</span>
            </div>
            <div className='md:flex-none flex flex-wrap-reverse md:flex-wrap '>
                <div className='flex w-full md:w-fit flex-wrap pr-0 md:pr-2 justify-start mt-4 md:mt-0'>
                  <button 
                      data-testid='followStatus-button'
                      onClick={gotoTrackingNo} 
                      className={' w-full md:w-[235px] h-[48px] py-3 px-5  text-base font-medium border border-grey-300  rounded-lg border-radius-other bg-white text-black '}>
                        ติดตามสถานะรายการอื่นๆ
                  </button>
                </div>
                <div className='w-full md:w-fit flex  flex-wrap  pl-0 md:pl-2 justify-end  '>

                  <button 
                      data-testid='submit-doc-online-button'
                      onClick={gotoInformNew} 
                      className={'w-full md:w-[149px] h-[48px] py-3 px-5 text-base font-medium  rounded-lg   '+ ( (false)? ' bg-grey-600 text-white ' : ' bg-green-500 text-white ')}>
                        ทำรายการอื่นต่อ
                  </button>
                </div>
            </div>
            <div className=' w-full flex md:hidden flex-wrap'>
              <span className='flex text-base text-green-500 mt-6 my-auto w-full text-center justify-center'>กลับสู่หน้าเว็บไทยวิวัฒน์</span>
            </div>
          </div>

        </div>
      </div>

  </div>
  )
}

export default InformPage;